import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';

import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from 'src/models/Ivrs/Nodes/baseIvrNode';

enum GladlyEntityType {
  CUSTOMER = 'customer',
}

class ExternalDataType {
  @IsString()
  name: string;

  @IsString()
  version: string;
}

export default class ExternalData extends BaseIvrNode {
  @IsString()
  gladlyEntityType: GladlyEntityType;

  @IsString()
  gladlyEntityId: string;

  @Type(() => ExternalDataType)
  dataType: ExternalDataType;

  @IsString()
  @IsOptional()
  dataTransformation: string;

  @IsString()
  @IsOptional()
  nextId?: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;
}
